import AppBar from '@mui/material/AppBar';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

import Logo from 'src/components/logo';
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { bgBlur } from 'src/theme/css';

import { useWhitelabelStore } from 'src/store/whitelabel/whitelabel.store';
import { useMeStore } from 'src/store/me/me.store';
import { IconButton, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import Iconify from 'src/components/iconify';
import { useAuthStore } from 'src/auth/store/auth.store';
import { useNavigate } from 'react-router-dom';
import { paths } from 'src/routes/paths';
import { HEADER } from '../config-layout';
import HeaderShadow from './header-shadow';

// ----------------------------------------------------------------------

export default function HeaderSimple() {
  const theme = useTheme();
  const navigate = useNavigate();

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

  return (
    <AppBar>
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Logo customLogo={useWhitelabelStore.getState().whitelabel?.logo ?? '/logo/logo-nectar-laranja.png'} />
        {useAuthStore.getState().isAuthenticated && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h6">{useMeStore.getState().me?.name}</Typography>
            <IconButton
              size="small"
              onClick={async () => {
                await useAuthStore.getState().logout();
                navigate(paths.auth.login);
              }}
            >
              <Iconify icon="material-symbols:logout" color={theme.palette.error.main} />
            </IconButton>
          </Stack>
        )}
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
